import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, register, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      navigate(user.role === "member" ? "/app" : "/admin", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = mode === "login" ? await login(email, password) : await register(email, password, name);
    setLoading(false);
    if (!result.success) {
      setError(result.error);
      return;
    }
    navigate(result.user.role === "member" ? "/daftar" : "/admin", { replace: true });
  };

  return (
    <div className="min-h-screen bg-piks-black flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/piks-logo.png?v=7" alt="Bodyguard Sarawak" className="h-12 w-12 object-contain" />
          <div className="text-left">
            <p className="font-display text-white text-base font-extrabold tracking-wide">BODYGUARD SARAWAK</p>
            <p className="text-[10px] text-piks-gold/80">PERSATUAN PENGAWAL PERIBADI SARAWAK</p>
          </div>
        </Link>

        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <h1 className="font-display text-xl font-bold text-piks-black mb-1">{mode === "login" ? "Log Masuk" : "Daftar Akaun"}</h1>
          <p className="text-sm text-piks-muted mb-6">{mode === "login" ? "Masuk untuk mengakses portal ahli PPPS." : "Daftar akaun untuk memulakan permohonan keahlian."}</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === "register" && (
              <div>
                <Label htmlFor="name">Nama Penuh</Label>
                <Input id="name" data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1.5" />
              </div>
            )}
            <div>
              <Label htmlFor="email">Emel</Label>
              <Input id="email" type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Kata Laluan</Label>
              <Input id="password" type="password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
            </div>

            {error && <p className="text-sm text-piks-red" data-testid="login-error-message">{error}</p>}

            <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full h-11 bg-piks-black hover:bg-piks-black/90 font-semibold">
              {loading ? "Sila tunggu..." : mode === "login" ? "LOG MASUK" : "DAFTAR"}
            </Button>
          </form>

          <p className="text-center text-sm text-piks-muted mt-6">
            {mode === "login" ? "Belum ada akaun?" : "Sudah ada akaun?"}{" "}
            <button
              onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
              data-testid="login-toggle-mode-btn"
              className="text-piks-black font-semibold hover:text-piks-red"
            >
              {mode === "login" ? "Daftar di sini" : "Log masuk di sini"}
            </button>
          </p>
          <p className="text-center text-sm text-piks-muted mt-3 pt-3 border-t border-piks-border">
            Ahli lama PPPS sebelum ini?{" "}
            <Link to="/tuntut-keahlian" data-testid="login-claim-membership-link" className="text-piks-black font-semibold hover:text-piks-red">
              Tuntut keahlian anda di sini
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
